import React, { useState } from "react";
import Dybdekort from "./Features/Maps/Dybdekort";
import Satelite from "./Features/Maps/Satelite";
import DepthLegend from "./UIComponents/DepthLegend";
import Layer from "./UIComponents/LayerPick/Layer";
import MapPicker from "./UIComponents/MapPicker/MapPicker";
import StreetMap from "./Features/Maps/StreetMap";

const labels = {
  street: {
    da: "Kort",
    en: "Street Map",
    de: "Straßenkarte",
  },
  satelite: {
    da: "Satellit",
    en: "Satellite",
    de: "Satelliten",
  },
  depth: {
    da: "Dybdekort",
    en: "Depth Map",
    de: "Tiefenkarte",
  },
};

/*
 * This component displays the map tiles and the map picker for controlling the different map types
 */

const MapTiles = (props) => {
  const [mapType, setMapType] = useState<"street" | "satelite">("street");
  const [showDepth, setShowDepth] = useState(false);

  return (
    <div>
      <MapPicker>
        <div style={{ display: props.display || "none" }}>
          <Layer
            className="mapPicker"
            text={labels.street[props.language]}
            active={mapType === "street" && !showDepth}
            onClick={() => {
              setMapType("street");
              setShowDepth(false);
            }}
          />
          <Layer
            className="mapPicker"
            text={labels.satelite[props.language]}
            active={mapType === "satelite"}
            onClick={() => {
              setMapType("satelite");
              setShowDepth(false);
            }}
          />
          <Layer
            className="mapPicker"
            text={labels.depth[props.language]}
            active={showDepth}
            onClick={() => {
              setMapType("street");
              setShowDepth(true);
            }}
          />
        </div>
      </MapPicker>

      {mapType === "street" && <StreetMap />}
      {mapType === "satelite" && <Satelite />}
      {showDepth && <Dybdekort />}
      {showDepth && <DepthLegend />}
    </div>
  );
};

export default MapTiles;
